module.exports = __webpack_public_path__ + "static/assets/b2297aecefbf407f85e2541342961af8.png";